(function () {
  var dataEl = document.getElementById('CollectionScrollData');
  var appendEl = document.getElementById('CrossCollectionAppend');
  if (!dataEl || !appendEl || !('IntersectionObserver' in window)) return;

  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var seq = (data.sequence || []).filter(function (x) { return x && x.handle; });
  if (seq.length < 2) return;

  // Rotate: start after current, wrap, exclude current -> append order.
  var idx = seq.findIndex(function (x) { return x.handle === data.current; });
  if (idx === -1) idx = 0;
  var order = seq.slice(idx + 1).concat(seq.slice(0, idx));

  // Hide the no-JS numbered pagination (JS takes over).
  var pag = document.querySelector('#Collection .pagination');
  if (pag) { var pw = pag.closest('ul, div') || pag; pw.style.display = 'none'; }

  window.__crossCollectionBlocks = [];

  // ---- Scroll-spy: highlight active nav + update URL/title (replaceState) ----
  function pathOf(u) { try { return new URL(u, location.origin).pathname; } catch (e) { return u; } }

  function setActiveNav(navUrl) {
    var target = pathOf(navUrl);
    ['.sidebar-nav__link', '.shop-horizontal-menu__link'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (a) {
        var on = pathOf(a.getAttribute('href')) === target;
        a.classList.toggle(sel.slice(1) + '--active', on);
        var li = a.closest('li');
        if (li && sel === '.sidebar-nav__link') li.classList.toggle('sidebar-nav__item--active', on);
      });
    });
  }

  var currentState = { url: null };
  function activate(url, title, navUrl) {
    if (!url || currentState.url === url) return;
    currentState.url = url;
    setActiveNav(navUrl || url);
    try { history.replaceState(null, '', url); } catch (e) {}
    if (title) document.title = title;
  }

  var spy = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        var el = e.target;
        activate(el.getAttribute('data-url'), el.getAttribute('data-title'), el.getAttribute('data-nav-url'));
      }
    });
  }, { rootMargin: '-100px 0px -70% 0px' });

  // ---- Placeholders up front (reserve space), then eager-load all content ----
  // Every remaining category gets a block immediately, so the page reaches its
  // (approximate) full height right away — the footer sits near the true bottom
  // and there is no false "end of page" before content loads.
  function buildBlock(entry) {
    var block = document.createElement('div');
    block.className = 'cross-collection-block cross-collection-block--loading';
    block.setAttribute('data-handle', entry.handle);
    block.setAttribute('data-url', entry.url);
    block.setAttribute('data-title', entry.title);
    block.setAttribute('data-nav-url', entry.navUrl || entry.url);
    var h = document.createElement('h2');
    h.className = 'cross-collection-block__title';
    h.textContent = entry.title;
    block.appendChild(h);
    return block;
  }

  var blocks = order.map(function (entry) {
    var block = buildBlock(entry);
    appendEl.appendChild(block);
    window.__crossCollectionBlocks.push(block);
    spy.observe(block);
    return { entry: entry, block: block };
  });

  function fill(item) {
    fetch('/collections/' + item.entry.handle + '?section_id=' + encodeURIComponent(data.section_id), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.querySelector('#Collection .grid--view-items');
        item.block.classList.remove('cross-collection-block--loading');
        if (grid && grid.querySelector('.grid__item')) {
          item.block.appendChild(grid);
        } else {
          // Empty/failed category: remove the block so it reserves no space.
          if (item.block.parentNode) item.block.parentNode.removeChild(item.block);
          var i = window.__crossCollectionBlocks.indexOf(item.block);
          if (i > -1) window.__crossCollectionBlocks.splice(i, 1);
        }
      })
      .catch(function () {
        // Network error: drop the reserved space; keep the page consistent.
        item.block.classList.remove('cross-collection-block--loading');
      });
  }

  // Kick off all categories at once (order is already fixed by the placeholders).
  blocks.forEach(fill);

  // Register the original (server-rendered) collection as the first spy target.
  var originalGrid = document.querySelector('#Collection .grid--view-items');
  if (originalGrid) {
    originalGrid.setAttribute('data-url', location.pathname);
    originalGrid.setAttribute('data-title', document.title);
    var selfEntry = seq.find(function (x) { return x.handle === data.current; });
    originalGrid.setAttribute('data-nav-url', selfEntry ? selfEntry.navUrl : location.pathname);
    spy.observe(originalGrid);
  }
})();
